import { Stack } from '@mui/material';
import { ApiResultModal } from '../../../../components/modal/ApiResultHandler';
import { ApproveModal } from '../../../../components/modal/ApproveModal';
import { ModalText, useModalToggle } from '../../../../components/modal/Modal';
import { PrimaryOutlinedButton } from '../../../../components/style/ButtonStyle';
import { useAuthAxios } from '../../../../hooks/useAuthAxios';
import { DeleteIcon } from '../../../../layouts/dashboard/nav/IconButton';

export function DeleteFacilityButton({ facilityId, getResult }: any) {
  const [removeResult, remove] = useAuthAxios({
    method: 'DELETE',
    url: `/api/v1/facility/${facilityId}`,
  });
  const { on, open, close } = useModalToggle();
  return (
    <>
      <PrimaryOutlinedButton
        onClick={open}
        startIcon={<DeleteIcon />}
        sx={{ maxWidth: 156 }}
      >
        삭제하기
      </PrimaryOutlinedButton>
      <ApproveModal
        on={on}
        onClose={close}
        title="삭제하시겠습니까?"
        children={
          <Stack direction="row" justifyContent="center" sx={{ pt: 3, pb: 5 }}>
            <ModalText>삭제된 데이터는 복구되지 않습니다.</ModalText>
          </Stack>
        }
        onConfirm={() => remove()}
        isPrimaryColor={false}
      />

      <ApiResultModal
        apiResult={removeResult}
        successCode={200}
        successTitle={<>삭제 완료</>}
        successContent="시설물이 삭제되어 페이지를 새로고침합니다."
        successConfirmText="확인"
        onSuccessClose={() => {
          close();
          window.location.reload();
        }}
        failTitle={<>관리자에게 문의해주세요.</>}
        failContent={'문제가 발생했습니다. 관리자에게 문의해주세요.'}
      />
    </>
  );
}
